export default "/images/vendor/flag-icons/flags/4x3/lk.svg?fd529379b814c9d95d498436aa2a9d51";